import { cookieNameBesBikeShared } from '@/configs/constants';

export const getStorage = (key: string, isParse: boolean = false) => {
    const value = localStorage.getItem(key) ?? sessionStorage.getItem(key);
    if (!isParse || !value) {
        return value;
    }
    return JSON.parse(value);
};

export const saveLocalStorage = (key: string, value: string, isStringify: boolean = false) => {
    const saveValue = isStringify ? JSON.stringify(value) : value;
    localStorage.setItem(key, saveValue);
};

export const removeStorage = (keys: string[]) => {
    if (keys.length > 0) {
        keys.forEach((key) => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
    }
};

export const saveToSession = (key: string, data: any) => {
    sessionStorage.setItem(key, JSON.stringify(data));
};

export const getFromSession = (key: string) => {
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
};

export const removeFromSession = (keys: string[]) => {
    if (keys.length > 0) {
        keys.forEach((key) => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
    }
};

export const getCookie = (name: string): string | undefined => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : undefined;
};

export const setCookieAuth = (
    username: string,
    token: string,
    days: number
) => {
    let expires = '';
    let expiration = '';

    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expiration = `${date.toUTCString()}`;
    expires = `; expires=${date.toUTCString()}`;

    const cookieValue = `${username}|${expiration}|${token}`;
    const cookieName = cookieNameBesBikeShared;

    document.cookie = `${cookieName}=${encodeURI(cookieValue)}${expires}; path=/; SameSite=Lax`;
};

export const deleteCookie = (name: string) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
};

export const saveCurrentHref = () => {
    const currentHref = window.location.href;
    if (currentHref?.length > 0) {
        saveToSession('currentHref', currentHref);
    }
};
